]<template>
  <div ref="gallery" class="animated-gallery">
    <div v-for="(imageArr,ind) in mappedImages" :key="ind" class="animated-gallery__item" :class="{'stacked': imageArr.length ==2}">
      <KenticoImage v-for="(image, index) in imageArr" :key="`${image.name}__${index}`" :src="image.url" />
    </div>
  </div>
</template>
<script>

export default {
  props: {
    images: { type: Array, required: true },
  },
  data: function() {
    return { mappedImages: [] };
  },
  created() {

    this.images.map((image, index)=>{
      let ind = 0;
      if (index <= 1 ) {
        ind = 0;
      } else if (index == 2) {
        ind = 1;
      } else if (index == 3 || index == 4) {
        ind = 2;
      } else if (index == 5) {
        ind = 3;
      } else if (index == 6 || index == 7) {
        ind = 4;
      } else if (index == 8) {
        ind = 5;
      } else if (index == 9 || index == 10) {
        ind = 6;
      }

      this.mappedImages[ind] = Array.isArray(this.mappedImages[ind]) ? this.mappedImages[ind] : [];
      this.mappedImages[ind].push(image);


    });
  },
};
</script>

<style lang="scss">
@import '~/assets/scss/atomic/components/_animated-gallery.scss';
</style>
